// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"126e40c0","239":"8536a45f","455":"1ec60ce0"}[chunkId] + ".chunk.js";
};